import fetch from '../utils/fetch'

export function getItemParamsBylang (data) {
  return fetch({
    url: '/goods/get_item_params_bylang',
    method: 'post',
    params: data
  })
}
export function putItemParamsBylang (data) {
    return fetch({
      url: '/goods/update_items_lang',
      method: 'post',
      params: data
    })
}